import "./style.css"
export const Footer=()=>{
    return(
        <p className="footer">React Project - 2022</p>
    )
}